"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var component_icon_font_1 = __importDefault(require("@rotaryintl/component-icon-font"));
var component_wbr_string_1 = __importDefault(require("@rotaryintl/component-wbr-string"));
var hook_use_bem_classes_1 = __importDefault(require("@rotaryintl/hook-use-bem-classes"));
var hook_use_on_click_outside_1 = __importDefault(require("@rotaryintl/hook-use-on-click-outside"));
var classnames_1 = __importDefault(require("classnames"));
var DynamicDataCard = function (_a) {
  var _b;
  var _c, _d, _e, _f, _g;
  var metadataName = _a.metadataName,
    dataList = _a.dataList,
    parentState = _a.state;
  if (!dataList || dataList.length <= 0) {
    return null;
  }
  // Manage state locally
  // unless a `useState` array has been passed from the parent component.
  var localState = (0, react_1.useState)(dataList[0].id);
  var _h = parentState !== null && parentState !== void 0 ? parentState : localState,
    selectedDataId = _h[0],
    setSelectedDataId = _h[1];
  var _j = (0, react_1.useState)(false),
    isHeadPanelOpen = _j[0],
    setIsHeadPanelOpen = _j[1];
  var outsideClickRef = (0, react_1.useRef)(null);
  (0, hook_use_on_click_outside_1.default)(outsideClickRef, function () {
    return setIsHeadPanelOpen(false);
  });
  var selectedData = (_c = dataList.find(function (data) {
    return data.id === selectedDataId;
  })) !== null && _c !== void 0 ? _c : dataList[0];
  var bem = (0, hook_use_bem_classes_1.default)('rwc-dynamic-data-card');
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: bem()
  }, {
    children: [dataList.length > 1 ? (0, jsx_runtime_1.jsxs)("div", __assign({
      ref: outsideClickRef,
      className: bem('head-wrapper')
    }, {
      children: [(0, jsx_runtime_1.jsxs)("button", __assign({
        title: selectedData.title,
        "aria-haspopup": "menu",
        "aria-controls": "".concat(metadataName, "-menu"),
        "aria-expanded": isHeadPanelOpen,
        onClick: function () {
          return setIsHeadPanelOpen(!isHeadPanelOpen);
        },
        className: (0, classnames_1.default)(bem('head'), (_b = {}, _b[bem('head', 'open')] = isHeadPanelOpen, _b))
      }, {
        children: [(0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
          tag: "h4"
        }, {
          children: selectedData.title
        })), (0, jsx_runtime_1.jsx)(component_icon_font_1.default, {
          type: "fas-angle-down",
          size: "16"
        })]
      })), (0, jsx_runtime_1.jsx)("div", __assign({
        className: (0, classnames_1.default)(bem('head-panel'), isHeadPanelOpen && bem('head-panel', 'open'))
      }, {
        children: (0, jsx_runtime_1.jsx)("ul", __assign({
          role: "menu",
          "aria-label": metadataName,
          id: "".concat(metadataName, "-menu"),
          className: (0, classnames_1.default)(bem('head-panel-options'), isHeadPanelOpen && bem('head-panel-options', 'open'))
        }, {
          children: dataList.map(function (data) {
            return (0, jsx_runtime_1.jsx)("li", {
              children: (0, jsx_runtime_1.jsxs)("button", __assign({
                role: "menuitemradio",
                "aria-checked": selectedDataId === data.id,
                className: bem('head-panel-option'),
                onClick: function () {
                  setIsHeadPanelOpen(false);
                  setSelectedDataId(data.id);
                }
              }, {
                children: [(0, jsx_runtime_1.jsx)(component_icon_font_1.default, {
                  className: (0, classnames_1.default)(bem('head-panel-option-check'), selectedDataId === data.id && bem('head-panel-option-check', 'selected')),
                  type: "fas-check",
                  style: {
                    height: 14,
                    width: 14
                  }
                }), (0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
                  tag: "span"
                }, {
                  children: data.title
                }))]
              }))
            }, "option-".concat(data.title));
          })
        }))
      }))]
    })) : (0, jsx_runtime_1.jsx)("div", __assign({
      className: bem('head')
    }, {
      children: (0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
        tag: "h4"
      }, {
        children: selectedData.title
      }))
    })), (0, jsx_runtime_1.jsxs)("div", __assign({
      className: bem('body')
    }, {
      children: [(_d = selectedData.textGroups) === null || _d === void 0 ? void 0 : _d.map(function (textGroup) {
        var _a;
        return (0, jsx_runtime_1.jsxs)("div", {
          children: [(0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
            tag: "p",
            className: bem('body-label')
          }, {
            children: textGroup.label
          })), (_a = textGroup.lines) === null || _a === void 0 ? void 0 : _a.map(function (line) {
            return (0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
              tag: "p",
              className: bem('body-text')
            }, {
              children: line
            }), "txt-line-".concat(line));
          })]
        }, "textGroup-".concat(textGroup.label));
      }), selectedData.link && (0, jsx_runtime_1.jsxs)("a", __assign({
        className: bem('body-link'),
        href: (_e = selectedData.link) === null || _e === void 0 ? void 0 : _e.linkUrl,
        target: (_f = selectedData.link) === null || _f === void 0 ? void 0 : _f.linkTarget
      }, {
        children: [(0, jsx_runtime_1.jsx)(component_wbr_string_1.default, __assign({
          tag: "span"
        }, {
          children: (_g = selectedData.link) === null || _g === void 0 ? void 0 : _g.linkText
        })), (0, jsx_runtime_1.jsx)(component_icon_font_1.default, {
          type: "fas-arrow-right",
          size: "16"
        })]
      }))]
    }))]
  }));
};
exports.default = DynamicDataCard;